import { RefObject } from "react";

export const updateListPosition = (
    listElement: RefObject<HTMLElement>,
    selectField: RefObject<HTMLElement>,
    setIsOpen: (value: boolean) => void,
    scrollParent: HTMLElement | null,
    noChangeWidth?: boolean,
) => {
    if (listElement.current && selectField.current) {
        const {
            x: selectX,
            y: selectY,
            width: selectWidth,
            height: selectHeight,
        } = selectField.current.getBoundingClientRect();
        const listHeight = listElement.current.getBoundingClientRect().height;
        const spacing = 4;
        let newY = selectY + selectHeight + spacing;
        const listBottom = newY + listHeight;

        if (listBottom > window.innerHeight - 24) newY -= selectHeight + listHeight + spacing * 2;

        listElement.current.style.setProperty("transform", `translate(${selectX}px, ${newY}px)`);
        listElement.current.style.setProperty("opacity", "1");
        if (!noChangeWidth) listElement.current.style.setProperty("width", `${selectWidth}px`);

        if (scrollParent) {
            const { y: scrollTop, height: scrollHeight } = scrollParent.getBoundingClientRect();

            if (selectY + selectHeight > scrollTop + scrollHeight || selectY < scrollTop) setIsOpen(false);
        }
    }
};

export const getScrollParent = (node: HTMLElement | null, isPagesView: boolean): HTMLElement | null => {
    if (node === null) {
        return null;
    }
    if (node.scrollHeight > node.offsetHeight || (!isPagesView && node.className.includes("scrollable"))) {
        return node;
    } else {
        return getScrollParent(node.parentNode as HTMLElement | null, isPagesView);
    }
};
